import { Instagram, Mail, ArrowUp } from "lucide-react";
import { scrollToId } from "@/lib/scrollTo";

export const Footer = () => (
  <footer className="bg-ink text-cream pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8">
        <div>
          <p className="font-display font-extrabold uppercase text-4xl sm:text-6xl leading-[0.95] tracking-tight">
            EVOLVE <span className="text-stroke-cream">WITH ROSA</span>
          </p>
          <p className="font-hand text-2xl sm:text-3xl text-pink mt-3 -rotate-1">
            start where you are. evolve into who you're meant to be.
          </p>
        </div>
        <div className="flex items-center gap-3" data-testid="footer-socials">
          <a
            href="https://www.instagram.com/gymwrosa"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            data-testid="footer-social-instagram"
            className="w-11 h-11 border-[3px] border-cream flex items-center justify-center hover:bg-pink hover:border-pink transition-colors"
          >
            <Instagram className="w-5 h-5" />
          </a>
          <a
            href="mailto:rosacaracci@icloud.com"
            aria-label="Email Rosa"
            data-testid="footer-social-email"
            className="w-11 h-11 border-[3px] border-cream flex items-center justify-center hover:bg-pink hover:border-pink transition-colors"
          >
            <Mail className="w-5 h-5" />
          </a>
          <p className="font-hand text-2xl text-cream/60 ml-2" data-testid="footer-instagram-handle">@gymwrosa</p>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-cream/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm font-semibold text-cream/50">
        <p>© {new Date().getFullYear()} Evolve With Rosa. All rights reserved.</p>
        <p className="font-hand text-lg text-cream/70">made with faith, grit & plenty of chalk ★</p>
        <button onClick={() => scrollToId("hero")} data-testid="footer-back-to-top" className="inline-flex items-center gap-2 hover:text-pink transition-colors uppercase font-bebas tracking-[0.2em]">
          back to top <ArrowUp className="w-4 h-4" />
        </button>
      </div>
    </div>
  </footer>
);
